import {
  Layers, Users, Hash, Coins, BarChart3,
  Calculator, Percent, Landmark,
} from 'lucide-react'
import { StatsCard } from '@/components/dashboard/StatsCard'
import { DashboardSectionHeader } from '@/components/dashboard/DashboardSectionHeader'
import { useStakingHealth } from '@/hooks/useStakingHealth'
import { formatNumber } from '@/lib/utils'

export function StakingHealthSection() {
  const { data, isLoading } = useStakingHealth()

  return (
    <div>
      <DashboardSectionHeader
        icon={Layers}
        title="DTR Staking Health"
      />
      <div className="grid gap-3 sm:gap-4 grid-cols-2 lg:grid-cols-4">
        <StatsCard
          title="Total DTR Staked"
          value={data ? formatNumber(data.totalDtrStaked) : '0'}
          icon={Layers}
          loading={isLoading}
        />
        <StatsCard
          title="Unique Stakers"
          value={data ? (data.uniqueStakers !== null ? data.uniqueStakers.toLocaleString() : 'N/A') : '0'}
          icon={Users}
          loading={isLoading}
        />
        <StatsCard
          title="Current Epoch"
          value={data ? `#${data.currentEpoch}` : '#0'}
          subtitle={data?.currentEpochStatus || undefined}
          icon={Hash}
          loading={isLoading}
        />
        <StatsCard
          title="Total SOL Distributed"
          value={data ? `${data.totalSolDistributed.toFixed(4)} SOL` : '0.0000 SOL'}
          subtitle="All-time"
          icon={Coins}
          loading={isLoading}
        />
        <StatsCard
          title="Current Epoch Revenue"
          value={data ? `${data.currentEpochRevenue.toFixed(4)} SOL` : '0.0000 SOL'}
          icon={BarChart3}
          loading={isLoading}
        />
        <StatsCard
          title="Estimated Next Payout"
          value={data ? `${data.estimatedNextPayout.toFixed(4)} SOL` : '0.0000 SOL'}
          subtitle="50% of epoch revenue"
          icon={Calculator}
          loading={isLoading}
        />
        <StatsCard
          title="Staking APY"
          value={data?.stakingApy !== null && data?.stakingApy !== undefined ? `${data.stakingApy.toFixed(1)}%` : 'Coming Soon'}
          icon={Percent}
          warning={data?.stakingApy === null || data?.stakingApy === undefined ? 'Requires DTR price feed' : undefined}
          loading={isLoading}
        />
        <StatsCard
          title="Rewards Vault Balance"
          value={data ? `${data.rewardsVaultBalanceSOL.toFixed(4)} SOL` : '0.0000 SOL'}
          icon={Landmark}
          loading={isLoading}
        />
      </div>
    </div>
  )
}
